var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewPort",staticClass:"viewPort use-pointer",style:({
    top: _vm.top + 'px',
    left: _vm.left + 'px',
    width: _vm.documentAreaWidth + 'px',
    height: _vm.documentAreaHeight + 'px'
  }),attrs:{"id":"viewPort"},on:{"click":_vm.clickAction,"dragstart":_vm.dragAction,"mousedown":_vm.pstart,"mousemove":_vm.pmove,"mouseup":_vm.pend,"touchstart":_vm.tstart,"touchmove":_vm.tmove,"touchcancel":_vm.tcancel,"touchend":_vm.tend}},[_c('transition',{attrs:{"name":_vm.slideDir},on:{"after-leave":_vm.afterLeaveAction}},[(_vm.dispOne)?_c('img',{key:"page1",ref:"page1",staticClass:"bookpageImage no-pointer",style:({
        top: '0px',
        left: '0px',
        width: '100vw',
        height: '100%'
      }),attrs:{"id":"page1","src":_vm.viewImage1}}):_vm._e(),(!_vm.dispOne)?_c('img',{key:"page2",ref:"page2",staticClass:"bookpageImage no-pointer",style:({
        top: '0px',
        left: '0px',
        width: '100vw',
        height: '100%'
      }),attrs:{"id":"page2","src":_vm.viewImage2}}):_vm._e()]),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.moving || _vm.moveAnimating),expression:"moving || moveAnimating"}],key:"page0",ref:"page0",staticClass:"bookpageImage no-pointer",style:({
      top: '0px',
      left: '100vw',
      width:'100vw',
      height: '100%'
     }),attrs:{"id":"page0","src":_vm.viewImage0}}),(_vm.loading)?_c('div',[(_vm.loading)?_c('div',{staticClass:"loader wf-mincho"}):_vm._e(),_c('div',{staticClass:"loader_message"},[_c('pre',{staticStyle:{"font-size":"0.9rem","font-family":"'Noto Serif JP', serif"}},[_vm._v(_vm._s(_vm.loadingMessage))])])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }